import { useContext, useEffect } from "react";
import { Outlet } from "react-router";
import Toastify from "toastify-js";
import { pusher } from "..";
import HomeHeader from "../components/layouts/HomeHeader";
import HeaderLink from "../components/shared/HeaderLink";
import { AuthContext } from "../contexts/AuthContext";

export default function MainLayout() {
  const { user } = useContext(AuthContext);
  const dashboardAccess = [1, 2, 3, 4, 7, 5, 9];
  const bookingsAccess = [2, 3, 5, 9];
  const revenueAccess = [2, 9, 5];
  const visitsAccess = [1, 2, 4, 5, 9];
  const analyticsAccess = [9];
  const servicesAccess = [2, 9];
  const financesAccess = [9];
  const customersAccess = [2, 5, 9];
  const testdrivesAccess = [2];
  const quotationsAccess = [2];
  const inCustomersAccess = [1];
  const vehiclesAccess = [1, 4];
  const qrcodesAccess = [1, 4];
  const manageAccess = [9];
  const assetsAccess = [9];

  useEffect(() => {
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  useEffect(() => {
    const quote = pusher.subscribe(`quotation`);
    quote.bind("sent", function (data: any) {
      Toastify({
        text: `New Quotation Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });
    return () => {
      pusher.unsubscribe("quotation");
    };
  }, []);

  return (
    <div className="flex bg-gray-100 h-screen font-toyota">
      <div className="w-full">
        <HomeHeader />
        <div className="bg-red-100 flex flex-col justify-center items-center border-b border-gray-300 overflow-x-auto">
          <div className="flex flex-row justify-center items-center ml-80 sm:ml-0">
            {dashboardAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to={"/dashboard"}
                className="px-2 text-black hover:text-toyota"
              >
                Dashboard
              </HeaderLink>
            ) : null}
            {revenueAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to={"/revenues"}
                className="px-2 text-black hover:text-toyota"
              >
                Revenues
              </HeaderLink>
            ) : null}
            {visitsAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to={"/visits"}
                className="px-2 text-black hover:text-toyota"
              >
                Visits
              </HeaderLink>
            ) : null}
            {servicesAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/service/history"
                className="px-2 text-black hover:text-toyota"
              >
                Services
              </HeaderLink>
            ) : null}

            {analyticsAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/analytics"
                className="px-2 text-black hover:text-toyota"
              >
                Analytics
              </HeaderLink>
            ) : null}
            {financesAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/finances"
                className="px-2 text-black hover:text-toyota"
              >
                Finances
              </HeaderLink>
            ) : null}
            {assetsAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to={"/assets"}
                className="px-2 text-black hover:text-toyota"
              >
                Assets
              </HeaderLink>
            ) : null}
            {customersAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/customers"
                className="px-2 text-black hover:text-toyota"
              >
                Customers
              </HeaderLink>
            ) : null}
            {bookingsAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/bookings"
                className="px-2 text-black hover:text-toyota"
              >
                Bookings
              </HeaderLink>
            ) : null}

            {quotationsAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/quotations"
                className="px-2 text-black hover:text-toyota"
              >
                Quotations
              </HeaderLink>
            ) : null}

            {testdrivesAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/testdrives"
                className="px-2 text-black hover:text-toyota"
              >
                Test Drives
              </HeaderLink>
            ) : null}

            {vehiclesAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/local/vehicles"
                className="px-2 text-black hover:text-toyota"
              >
                Vehicles
              </HeaderLink>
            ) : null}

            {qrcodesAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/local/qrcodes"
                className="px-2 text-black hover:text-toyota"
              >
                QR Codes
              </HeaderLink>
            ) : null}

            {inCustomersAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to="/local/customers"
                className="px-2 text-black hover:text-toyota"
              >
                Customers
              </HeaderLink>
            ) : null}

            {manageAccess.includes(user?.accessLevel) ? (
              <HeaderLink
                to={"/manage/customers"}
                className="px-2 text-black hover:text-toyota"
              >
                Manage
              </HeaderLink>
            ) : null}
          </div>
          {/* {user?.role?.name === "Super Admin" ? (
            <div className="flex flex-row justify-center items-center ml-80 sm:ml-0">
              <HeaderLink
                to={"/dashboard"}
                className="px-2 text-black hover:text-toyota"
              >
                Dashboard
              </HeaderLink>

              <HeaderLink
                to={"/revenues"}
                className="px-2 text-black hover:text-toyota"
              >
                Revenues
              </HeaderLink>

              <HeaderLink
                to={"/visits"}
                className="px-2 text-black hover:text-toyota"
              >
                Visits
              </HeaderLink>
              <HeaderLink
                to="/service/history"
                className="px-2 text-black hover:text-toyota"
              >
                Services
              </HeaderLink>

              <HeaderLink
                to="/analytics"
                className="px-2 text-black hover:text-toyota"
              >
                Analytics
              </HeaderLink>

              <HeaderLink
                to="/finances"
                className="px-2 text-black hover:text-toyota"
              >
                Finances
              </HeaderLink>

              <HeaderLink
                to="/customers"
                className="px-2 text-black hover:text-toyota"
              >
                Customers
              </HeaderLink>
              <HeaderLink
                to={"/manage/customers"}
                className="px-2 text-black hover:text-toyota"
              >
                Manage
              </HeaderLink>
            </div>
          ) : (
            <div className="flex flex-row justify-center items-center ml-80 sm:ml-0">
              <HeaderLink
                to={"/dashboard"}
                className="px-2 text-black hover:text-toyota"
              >
                Dashboard
              </HeaderLink>

              <HeaderLink
                to={"/visits"}
                className="px-2 text-black hover:text-toyota"
              >
                Visits
              </HeaderLink>
              <HeaderLink
                to="/service/history"
                className="px-2 text-black hover:text-toyota"
              >
                Services
              </HeaderLink>

              <HeaderLink
                to="/customers"
                className="px-2 text-black hover:text-toyota"
              >
                Customers
              </HeaderLink>
              <HeaderLink
                to="/bookings"
                className="px-2 text-black hover:text-toyota"
              >
                Bookings
              </HeaderLink>
              <HeaderLink
                to="/quotations"
                className="px-2 text-black hover:text-toyota"
              >
                Quotations
              </HeaderLink>
              <HeaderLink
                to="/testdrives"
                className="px-2 text-black hover:text-toyota"
              >
                Test Drives
              </HeaderLink>
            </div>
          )} */}
        </div>
        <Outlet />
      </div>
    </div>
  );
}
